"use strict";
/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const index_decoder_1 = require("@here/harp-datasource-protocol/index-decoder");
/**
 * `ThemedTileDecoder` implements an [[ITileDecoder]] which uses a [[Theme]] to apply styles to the
 * objects displayed in the map.
 *
 * By default, decoders are executed in web workers (using [[TileDecoderService]]) for performance
 * reasons.
 */
class ThemedTileDecoder {
    constructor() {
        this.m_storageLevelOffset = 0;
    }
    dispose() {
        // implemented in subclasses
    }
    decodeTile(data, tileKey, projection) {
        if (this.m_styleSetEvaluator === undefined) {
            return Promise.reject(new Error("No style is defined"));
        }
        return this.decodeThemedTile(data, tileKey, this.m_styleSetEvaluator, projection);
    }
    // tslint:disable:no-unused-variable
    getTileInfo(data, tileKey, projection) {
        return Promise.resolve(undefined);
    }
    // tslint:disable:no-unused-variable
    configure(styleSet, languages, options) {
        if (styleSet !== undefined) {
            this.m_styleSetEvaluator = new index_decoder_1.StyleSetEvaluator(styleSet);
        }
        if (languages !== undefined) {
            this.languages = languages;
        }
        if (options !== undefined && options.storageLevelOffset !== undefined) {
            this.m_storageLevelOffset = options.storageLevelOffset;
        }
    }
}
exports.ThemedTileDecoder = ThemedTileDecoder;
